import React from "react";
import Header from './Header'
import Footer from './Footer'

export default function About() {
  return (
    <div>
        <Header/>
        <div className='pb-5 bg-light'   style={{paddingTop:175}}>
      <section class="container my-lg-2 pb-lg-7">
        <div class="row align-items-center ">
          <div class="col-lg-5 py-3 py-lg-0">
            <h1 className='font-weight-bold text-secondary'>Our goals. Our mission.</h1>
            <h2 class="h3 text-secondary">How we help other companies to grow.</h2>
            <div class="py-4">
              <p class="callout">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud.
              </p>
            </div>
            <a
              class="btn-video btn-video-primary btn-video-sm me-3"
              href="https://www.youtube.com/watch?v=hTu0a4o97dU"
              lg-uid="lg0"
            ></a>
            {/* <span class="fs-sm text-muted">Get to know us better</span> */}
          </div>
          <div class="col-xl-6 col-lg-7 offset-xl-1 position-relative">
              <img src='/img/aboutus.svg' className='w-100'></img>
          </div>
        </div>
      </section>
      </div>
      <section class="container mb-5 pb-3 pb-lg-0 mb-lg-7" style={{marginTop:'3.5rem'}}>
        <h2 class="pb-4 mb-4 text-center font-weight-bold text-secondary">Our Team</h2>
        <div class="row mb-3">
            <div class="card card-curved-body card-hover border-0 shadow mx-auto" style={{maxWidth: '21rem'}}><a class="card-floating-icon" href="mailto:sarah.cole@example.com"><i class="ai-mail"></i></a>
              <div class="card-img-top card-img-gradient"><img src="https://around.createx.studio/img/team/02.jpg" class='w-100' alt="Sarah Cole"/></div>
              <div class="card-body text-center">
                <h3 class="h6 card-title mb-2">Gaurav Kumar</h3>
                <p class="fs-xs text-body mb-0">CEO, Co-Founder</p>
              </div>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
}
